<template>
  <div class="nettdoc-sensory-perception">
    <SectionHeader
      text="disruption of sensory perception"
      img="sensory-perception"
      alt="exhausted man"
      :collapsable="true"
      v-on:collapse="() => collapsed = !collapsed"
      :complete="store.sensoryPerceptionDetails.submitted"
    />
    <template v-if="collapsed">
      <SectionHeader text="lossOfTastePerception" :required="true" :dark="true" />
      <YesNo
        :model="store.sensoryPerceptionDetails.lossOfTastePerception"
        v-on:action="value => store.addSensoryPerceptionDetails('lossOfTastePerception', value)"
      />

      <template v-if="store.sensoryPerceptionDetails.lossOfTastePerception === 'yes'">
        <SectionHeader text="Since when do you feel the disruption?" :required="false" :dark="true" />
        <Dropdown
          label="please choose"
          :data="['A few hours', '1 day', '2 to 6 days', 'More than 1 week', '1 month']"
          :choice="store.lossOfTastePerceptionDetails.since"
          v-on:action="value => store.addLossOfTastePerceptionDetails('since', value)"
        />
        <SectionHeader text="How did the disruption set in?" :required="false" :dark="true" />
        <Dropdown
          label="please choose"
          :data="['Creeping', 'suddenly', 'caused by an injury / an accident', 'Triggered by a different incident']"
          :choice="store.lossOfTastePerceptionDetails.how"
          v-on:action="value => store.addLossOfTastePerceptionDetails('how', value)"
        />
        <SectionHeader text="cannotTasteAnything" :required="false" :dark="true" />
        <YesNo 
          :model="store.lossOfTastePerceptionDetails.cannotTasteAnything"
          v-on:action="value => store.addLossOfTastePerceptionDetails('cannotTasteAnything', value)"
        />
        <SectionHeader text="noDifferenceBetweenHotAndCold" :required="false" :dark="true" />
        <YesNo 
          :model="store.lossOfTastePerceptionDetails.noDifferenceBetweenHotAndCold"
          v-on:action="value => store.addLossOfTastePerceptionDetails('noDifferenceBetweenHotAndCold', value)"
        />
        <SectionHeader text="cannotTasteFlavor" :required="false" :dark="true" />
        <Dropdown
          label="please choose"
          :data="['Sweet', 'Sour', 'Salty', 'bitter', 'spicy']"
          :choice="store.lossOfTastePerceptionDetails.cannotTasteFlavor"
          v-on:action="value => store.addLossOfTastePerceptionDetails('cannotTasteFlavor', value)"
        />
      </template>

      <SectionHeader text="auditivePerceptionGotWorse" :required="true" :dark="true" />
      <YesNo
        :model="store.sensoryPerceptionDetails.auditivePerceptionGotWorse"
        v-on:action="value => store.addSensoryPerceptionDetails('auditivePerceptionGotWorse', value)"
      />

      <template v-if="store.sensoryPerceptionDetails.auditivePerceptionGotWorse === 'yes'">
        <CheckboxList 
          :data="['On both ears', 'Only on one ear']"
          :choice="store.auditivePerceptionGotWorseDetails.affectedEars"
          v-on:action="value => store.addAuditivePerceptionGotWorseDetails('affectedEars', value)"          
        />

        <SectionHeader text="cannotHearAnything" :required="false" :dark="true" />
        <YesNo
          :model="store.auditivePerceptionGotWorseDetails.cannotHearAnything"
          v-on:action="value => store.addAuditivePerceptionGotWorseDetails('cannotHearAnything', value)"
        />
        <template v-if="store.auditivePerceptionGotWorseDetails.cannotHearAnything === 'yes'">
          <CheckboxList 
            :data="['On both ears', 'Just on one ear']"
            :choice="store.auditivePerceptionGotWorseDetails.cannotHearAnythingOnEars"
            v-on:action="value => store.addAuditivePerceptionGotWorseDetails('cannotHearAnythingOnEars', value)"
          />
        </template>

        <SectionHeader text="feelingDizzy" :required="false" :dark="true" />
        <YesNo
          :model="store.auditivePerceptionGotWorseDetails.feelingDizzy"
          v-on:action="value => store.addAuditivePerceptionGotWorseDetails('feelingDizzy', value)"
        />
        <SectionHeader text="painInEars" :required="false" :dark="true" />
        <YesNo
          :model="store.auditivePerceptionGotWorseDetails.painInEars"
          v-on:action="value => store.addAuditivePerceptionGotWorseDetails('painInEars', value)"
        />
        <SectionHeader text="Since when do you feel the disruption?" :required="false" :dark="true" />
        <Dropdown
          label="please choose"
          :data="['A few hours', '1 day', '2 to 6 days', 'More than 1 week', '1 month']"
          :choice="store.auditivePerceptionGotWorseDetails.since"
          v-on:action="value => store.addAuditivePerceptionGotWorseDetails('since', value)"
        />
        <SectionHeader text="How did the disruption set in?" :required="false" :dark="true" />
        <Dropdown
          label="please choose"
          :data="['Creeping', 'suddenly', 'caused by an injury / an accident', 'Triggered by a different incident']"
          :choice="store.auditivePerceptionGotWorseDetails.how"
          v-on:action="value => store.addAuditivePerceptionGotWorseDetails('how', value)"
        />
      </template>

      <SectionHeader text="sightDisorder" :required="false" :dark="true" />
      <YesNo
        :model="store.sensoryPerceptionDetails.sightDisorder"
        v-on:action="value => store.addSensoryPerceptionDetails('sightDisorder', value)"
      />

      <template v-if="store.sensoryPerceptionDetails.sightDisorder === 'yes'">
        <CheckboxList 
          :data="['One side', 'Both sides']"
          :choice="store.sightDisorderDetails.affectedEyes"
          v-on:action="value => store.addSightDisorderDetails('affectedEyes', value)"
        />

        <SectionHeader text="seeingFuzzy" :required="false" :dark="true" />
        <YesNo
          :model="store.sightDisorderDetails.seeingFuzzy"
          v-on:action="value => store.addSightDisorderDetails('seeingFuzzy', value)"
        />
        <SectionHeader text="troubleSeeingNear" :required="false" :dark="true" />
        <YesNo
          :model="store.sightDisorderDetails.troubleSeeingNear"
          v-on:action="value => store.addSightDisorderDetails('troubleSeeingNear', value)"
        />
        <SectionHeader text="troubleSeeingFar" :required="false" :dark="true" />
        <YesNo
          :model="store.sightDisorderDetails.troubleSeeingFar"
          v-on:action="value => store.addSightDisorderDetails('troubleSeeingFar', value)"
        />
        <SectionHeader text="seeingDouble" :required="false" :dark="true" />
        <YesNo
          :model="store.sightDisorderDetails.seeingDouble"
          v-on:action="value => store.addSightDisorderDetails('seeingDouble', value)"
        />
        <SectionHeader text="sightLimitedToSides" :required="false" :dark="true" />
        <YesNo
          :model="store.sightDisorderDetails.sightLimitedToSides"
          v-on:action="value => store.addSightDisorderDetails('sightLimitedToSides', value)"
        />
        <SectionHeader text="cannotDifferenciateColors" :required="false" :dark="true" />
        <YesNo
          :model="store.sightDisorderDetails.cannotDifferenciateColors"
          v-on:action="value => store.addSightDisorderDetails('cannotDifferenciateColors', value)"
        />
        <SectionHeader text="feelingDizzy" :required="false" :dark="true" />
        <YesNo
          :model="store.sightDisorderDetails.feelingDizzy"
          v-on:action="value => store.addSightDisorderDetails('feelingDizzy', value)"
        />
        <SectionHeader text="Since when do you feel the disruption?" :required="false" :dark="true" />
        <Dropdown
          label="please choose"
          :data="['A few hours', '1 day', '2 to 6 days', 'More than 1 week', '1 month']"
          :choice="store.sightDisorderDetails.since"
          v-on:action="value => store.addSightDisorderDetails('since', value)"
        />
        <SectionHeader text="How did the disruption set in?" :required="false" :dark="true" />
        <Dropdown
          label="please choose"
          :data="['Creeping', 'suddenly', 'caused by an injury / an accident', 'Triggered by a different incident']"
          :choice="store.sightDisorderDetails.how"
          v-on:action="value => store.addSightDisorderDetails('how', value)"
        />
      </template>

      <SectionHeader text="senseOfSmellGotWorse" :required="false" :dark="true" />
      <YesNo
        :model="store.sensoryPerceptionDetails.senseOfSmellGotWorse"
        v-on:action="value => store.addSensoryPerceptionDetails('senseOfSmellGotWorse', value)"
      />

      <template v-if="store.sensoryPerceptionDetails.senseOfSmellGotWorse === 'yes'">
        <SectionHeader text="lostSenseOfSmell" :required="false" :dark="true" />
        <YesNo
          :model="store.senseOfSmellGotWorseDetails.lostSenseOfSmell"
          v-on:action="value => store.addSenseOfSmellGotWorseDetails('lostSenseOfSmell', value)"
        />
        <SectionHeader text="onlySpicyAndUnpleasentSmells" :required="false" :dark="true" />
        <YesNo
          :model="store.senseOfSmellGotWorseDetails.onlySpicyAndUnpleasentSmells"
          v-on:action="value => store.addSenseOfSmellGotWorseDetails('onlySpicyAndUnpleasentSmells', value)"
        />       

        <SectionHeader text="Since when do you feel the disruption?" :required="false" :dark="true" />
        <Dropdown
          label="please choose"
          :data="['A few hours', '1 day', '2 to 6 days', 'More than 1 week', '1 month']"
          :choice="store.senseOfSmellGotWorseDetails.since"
          v-on:action="value => store.addSenseOfSmellGotWorseDetails('since', value)"
        />
        <SectionHeader text="How did the disruption set in?" :required="false" :dark="true" />
        <Dropdown
          label="please choose"
          :data="['Creeping', 'suddenly', 'caused by an injury / an accident', 'Triggered by a different incident']"
          :choice="store.senseOfSmellGotWorseDetails.how"
          v-on:action="value => store.addSenseOfSmellGotWorseDetails('how', value)"
        />
      </template>
      
      <Button :text="edit ? 'Update' : 'Submit'" v-on:action="submit" :active="store.sensoryPerceptionDetailsComplete" />
    </template>
  </div>
</template>

<script>
import { observer } from "mobx-vue";

import SectionHeader from "../SectionHeader"
import YesNo from '../YesNo'
import Button from '../Button'
import Bodyparts from '../Bodyparts'
import Dropdown from '../Dropdown'
import CheckboxList from '../CheckboxList'
export default observer({
  name: "SensoryPerception",
  data() {
    return {
      collapsed: true
    };
  },
  props: {
    store: Object,
    edit: Boolean
  },
  components: {
    SectionHeader, YesNo, Button, Bodyparts, Dropdown, CheckboxList
  },
  methods: {
    submit: function() {
      this.store.sensoryPerceptionDetails.submitted = true
      for (const detail in this.store.sensoryPerceptionDetails) {
        const value = this.store.sensoryPerceptionDetails[detail]
        if (value === 'yes' && typeof this.store[detail+'Details'] === 'object') {
          localStorage.setItem(
            detail+'Details',
            JSON.stringify(this.store[detail+'Details'])
          )
        }
      }
      localStorage.setItem(
        "sensoryPerceptionDetails",
        JSON.stringify(this.store.sensoryPerceptionDetails)
      )
      if (this.edit) {
        this.$emit('close')
      } else {
        this.collapsed = !this.collapsed
        window.scrollTo(0,0)
      }
    }
  }
})
</script>

<style>
</style>